import { useLocation, useNavigate } from 'react-router-dom';

export function useGoBack() {
  const navigate = useNavigate();

  const location = useLocation();

  const back = (path: string) => {
    if (location.key === 'default') {
      navigate(path, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return back;
}
